// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-block-button[data-v-03c486a2]{display:-webkit-box;display:-ms-flexbox;display:flex;height:2em;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:azure;cursor:default;margin-top:1em}.add-block-button[data-v-03c486a2]:hover{background:#dbf9f9}", ""]);
// Exports
module.exports = exports;
